import { z } from 'zod/v4';

import { buttonHorizontalPositionSchema } from '../../../common/schemas/legacy/button-settings';

/**
 * Data shape for the `line` (divider) widget — the smallest of any widget in the
 * package: a single alignment bucket. Everything else the user can set lives in
 * the envelope's typed `styles` bag (see `./styles`), because the divider is
 * drawn by an `<hr>` whose border IS the widget.
 *
 * No visibility flags, no animation, no position grid: the host control panel
 * offers none of them, and the persisted JSON has never carried them.
 */
export const lineLegacyDataSchema = z.object({
    horizontalAlign: buttonHorizontalPositionSchema,
});
